import styled from 'styled-components'

const ErrorMessage = styled.div`
  margin-top: 0.33em;
  color: ${({ theme: { error } }) => error};
`

export default ErrorMessage
